/** DO NOT DELETE THE FOLLOWING LINES. THEY ARE USED FOR GULP */

// Injection starts
			
;( function ( $, window, document, undefined ) {

	const screenBreakpoints = {
		xxl: 1400,
		xl: 1220,
		lg: 1025,
		md: 768,
		sm: 576,
	};

	const isTouchDevice = () => {
		return ( ( 'ontouchstart' in window ) ||
			( navigator.maxTouchPoints > 0 ) ||
			( navigator.msMaxTouchPoints > 0 )
		);
	};

	const initHeader = () => {

		if ( $( '#masthead' ).length === 0 ) {
			return;
		}

		$( 'body' ).removeClass( 'has-fixed-header' );
		const height = $( '#masthead' ).outerHeight();

		const init_screen_orientation = () => {
			switch( window.orientation ) {
				case 0:
				case 180:
					$( 'html' ).removeClass( 'orientation-landscape' ).addClass( 'orientation-portrait' );
					break;

				case -90:
				case 90:
					$( 'html' ).addClass( 'orientation-landscape' ).removeClass( 'orientation-portrait' );
			}

			for ( const key in screenBreakpoints ) {
				$( 'body' ).removeClass( `has-screen-size-${key}` );
			}

			for ( const key in screenBreakpoints ) {
				if ( window.innerWidth >= screenBreakpoints[ key ] ) {
					$( 'body' ).addClass( `has-screen-size-${key}` );
					break;
				}
			}

			init_fixed_header();
		};

		const init_fixed_header = () => {
			if ( $( window ).scrollTop() > height ) {
				$( 'body' ).addClass( 'has-fixed-header' ).removeClass( 'after-fixed-header' ).css( { 'padding-top': height } );
			} else {
				$( 'body' ).removeClass( 'has-fixed-header' ).addClass( 'after-fixed-header' ).css( { 'padding-top': 'var(--global--admin-bar--height)' } );
			}

			if ( $( window ).scrollTop() > ( height + 400 ) ) {
				$( 'body' ).addClass( 'has-goto-top' );
				$( '#m3-goto-top-container' ).css({ 'opacity': 1 });
			} else {
				$( 'body' ).removeClass( 'has-goto-top' );
				$( '#m3-goto-top-container' ).css({ 'opacity': 0 });
			}
		};

		const do_when_orientation_changes = () => {
			init_screen_orientation();
			initTabbedContainers();
			initPageHero();
			initInnerFlushContainer();
			initM3TaxonomyList();
			initLeadership();
			initSectionWithIcon();
		};

		const debounce_fixed_header = _.debounce( init_fixed_header, 100 );
		const debounce_screen_orientation = _.debounce( do_when_orientation_changes, 300 );

		$( window ).on( 'scroll', debounce_fixed_header );
		$( window ).on( 'resize', debounce_screen_orientation );
		window.addEventListener( 'orientationchange', debounce_screen_orientation );
		init_fixed_header();
		do_when_orientation_changes();
	};

	const initTabbedContainerSwipper = ( container, idx ) => {
		const $container = $( container );

		let needInit = true;
		let tabbedSwiper = $container.data( 'm3_swiper' );
		if ( ( typeof tabbedSwiper !== 'undefined' ) && ( tabbedSwiper.has_swiper !== false ) ) {
			needInit = false;
		}

		if ( !needInit ) {
			return;
		}

		const sliderCont = container.querySelector( '.content-items-container' );
		if ( sliderCont === undefined ) {
			return;
		}

		let monitorSlideChanges = true;

		const doWhenSliderChanges = ( swipper_int ) => {
			if ( monitorSlideChanges ) {
				const lists = $( '.wp-block-group__inner-container .m3-tabbed-navigation > li' );
				if ( lists.length > 0 ) {
					lists.removeClass( 'active' );
					const list = lists[ swipper_int.realIndex ];
					if ( list ) {
						list.classList.add( 'active' );
					}
				}

				// Swiper pagination does not seem to update
				const paginations = $( '.swiper-pagination .swiper-pagination-bullet', $container );
				paginations.removeClass( 'swiper-pagination-bullet-active' );
				paginations[ swipper_int.realIndex ].classList.add( 'swiper-pagination-bullet-active' );
			}
		};

		let slide_hashes = [];

		if ( document.querySelectorAll( '.swiper-pagination' ).length === 0 ) {
			const el = document.createElement( 'div' );
			el.classList.add( 'swiper-pagination' );
			sliderCont.appendChild( el );
		}
		sliderCont.classList.add( 'swiper' );
		sliderCont.querySelector( '.wp-block-group__inner-container' ).classList.add( 'swiper-wrapper' );

		let withHash = false;
		container.querySelectorAll( '.content-items-container > .wp-block-group__inner-container > .wp-block-group' ).forEach( ( el ) => {
			el.classList.add( 'swiper-slide' );
			if ( el.id !== '' ) {
				if ( !withHash ) {
					withHash = true;
				}
				el.setAttribute( 'data-hash', el.id );
				slide_hashes.push( el.id );
			}
		});

		let options = {
			autoplay: false,
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true
			},
			on: {
				slideChange: doWhenSliderChanges
			}
		};

		if ( withHash ) {
			options[ 'hashNavigation' ] = {
				watchState: false,
				replaceState: true
			};
		}

		tabbedSwiper = new Swiper( '.swiper', options );
		$container.data( 'm3_swiper', {
			'swiper': tabbedSwiper,
			'has_swiper': true
		});

		$( '.wp-block-group__inner-container .m3-tabbed-navigation > li', $container ).css( 'height', 'auto' );
		setTimeout( () => {
			let tab_height = 0;
			$( '.wp-block-group__inner-container .m3-tabbed-navigation > li', $container ).each( ( idx, el ) => {
				if ( $( el ).outerHeight() > tab_height ) {
					tab_height = $( el ).outerHeight();
				}
			});
			$( '.wp-block-group__inner-container .m3-tabbed-navigation > li', $container ).css( 'height', tab_height );
		}, 300 );

		$( '.wp-block-group__inner-container .m3-tabbed-navigation > li > a', $container ).off().on( 'click', ( ev ) => {
			ev.preventDefault();
			ev.stopPropagation();
			$( '.wp-block-group__inner-container .m3-tabbed-navigation > li' ).removeClass( 'active' );
			$( ev.currentTarget ).parent( 'li' ).addClass( 'active' );
			const dest = $( ev.currentTarget ).attr( 'href' );
			if ( ( dest !== '' ) && ( slide_hashes.length > 0 ) ) {
				const idx = slide_hashes.indexOf( dest.replace( '#', '' ) );
				if ( idx !== -1 ) {
					monitorSlideChanges = false;
					tabbedSwiper.slideTo( idx );
					monitorSlideChanges = true;
				}
			}
		});

		if ( $( '.wp-block-group__inner-container .m3-tabbed-navigation > li.active' ).length === 0 ) {
			$( '.wp-block-group__inner-container .m3-tabbed-navigation > li' ).first().addClass( 'active' );
		}
	};

	const removeSwiper = ( container ) => {
		const sliderCont = container.querySelector( '.content-items-container' );
		if ( sliderCont === undefined ) {
			return;
		}

		const $container = $( container );

		const tabbedSwiper = $container.data( 'm3_swiper' );
		if ( ( typeof tabbedSwiper !== 'undefined' ) && ( tabbedSwiper.has_swiper !== false ) ) {
			tabbedSwiper.swiper.destroy();
			$container.data( 'm3_swiper', {
				'swiper': null,
				'has_swiper': false
			} );
		}

		$( '.swiper-pagination', $container ).remove();
		let swiper_classes = [];
		sliderCont.classList.forEach( ( a_class ) => {
			if ( a_class.indexOf( 'swiper' ) !== -1 ) {
				swiper_classes.push( a_class );
			}
		});

		swiper_classes.forEach( ( a_class ) => {
			sliderCont.classList.remove( a_class );
		});
		
		sliderCont.querySelector( '.wp-block-group__inner-container' ).classList.remove( 'swiper-wrapper' );
	};

	const initTabbedContainerSimple = ( container, idx ) => {
		const $container = $( container );

		let needInit = false;
		const tabbedSwiper = $container.data( 'm3_swiper' );
		if ( typeof tabbedSwiper === 'undefined' ) {
			needInit = true;
		} else if ( tabbedSwiper.has_swiper !== false ) {
			needInit = true;
		}

		if ( !needInit ) {
			return;
		}

		const sliderCont = container.querySelector( '.content-items-container' );
		if ( sliderCont === undefined ) {
			return;
		}

		let hashes = [];
		container.querySelectorAll( '.content-items-container > .wp-block-group__inner-container > .wp-block-group' ).forEach( ( el ) => {
			if ( el.id !== '' ) {
				hashes.push( el.id );
			}
		});

		removeSwiper( container );

		const groups = $( '.content-items-container > .wp-block-group__inner-container > .wp-block-group', $container );
		const hasActive = ( $( '.content-items-container > .wp-block-group__inner-container > .active', $container ).length > 0 );
		$( '.content-items-container > .wp-block-group__inner-container > .wp-block-group > .wp-block-group__inner-container > h3', $container ).off().on( 
			'click',
			( ev ) => {
				ev.preventDefault();
				ev.stopPropagation();
				groups.removeClass( 'active' );
				$( ev.currentTarget ).parents( '.wp-block-group' ).addClass( 'active' );
				$( 'html, body' ).animate(
					{
						scrollTop: ( $( ev.target ).offset().top - $( '#masthead' ).outerHeight() - 160 )
					}, {
						duration: 600
					}
				);
				const dest = $( ev.currentTarget ).parents( '.wp-block-group' ).attr( 'id' );
				if ( dest !== '' ) {
					history.pushState( { tab: dest }, '', `#${dest}` );
				}
			}
		);

		if ( !hasActive ) {
			let hash = window.location.hash;
			if ( hash ) {
				$( hash ).addClass( 'active' );
			} else {
				groups.first().addClass( 'active' );
			}
		}
	};

	const initTabbedContainers = () => {
		$( 'body' ).removeClass( 'has-m3-tabbed-content' );
		const containers = document.querySelectorAll( '.m3-tabbed-container' );
		if ( containers.length === 0 ) {
			return;
		}

		if ( window.innerWidth >= screenBreakpoints.lg ) {
			$( 'body' ).addClass( 'has-m3-tabbed-content' );
			containers.forEach( ( container, idx ) => {
				initTabbedContainerSwipper( container, idx );
			} );
		} else {
			$( 'body' ).addClass( 'has-m3-simple-tabbed-content' );
			containers.forEach( ( container, idx ) => {
				initTabbedContainerSimple( container, idx );
			} );
		}
	};

	const initSearch = () => {
		const search_modal = $( '.m3-search-form-modal' );
		if ( search_modal.length === 0 ) {
			return;
		}

		const search_trigger = $( '.m3-search-form-trigger' );
		if ( search_trigger.length === 0 ) {
			return;
		}

		const btn_close = $( '.btn-close', search_modal );

		const openSearchModal = () => {
			$( 'body' ).addClass( 'search-modal-appear' );
			search_modal.show();
			$( document ).on( 'keyup', handleEscClicked );
		};

		const closeSearchModal = () => {
			$( 'body' ).removeClass( 'search-modal-appear' );
			search_modal.hide();
			$( document ).off( 'keyup', handleEscClicked );
		};

		search_trigger.on( 'click', ( ev ) => {
			ev.preventDefault();
			let show_modal = false;
			const with_modals = [ 'lg', 'xl', 'xxl' ];
			for( let i = 0; i < with_modals.length; i++ ) {
				if ( $( 'body' ).hasClass( `has-screen-size-${with_modals[i]}` ) ) {
					show_modal = true;
					break;
				}
			}
			if ( show_modal ) {
				if ( $( 'body' ).hasClass( 'search-modal-appear' ) ) {
					closeSearchModal();
				} else {
					openSearchModal();
				}
			} else {
				$( '#primary-mobile-menu' ).trigger( 'click' );
			}
		});

		btn_close.on( 'click', ( ev ) => {
			ev.preventDefault();
			closeSearchModal();
		});

		const handleEscClicked = ( ev ) => {
			if ( ev.key == 'Escape' ) {
				if ( $( 'body' ).hasClass( 'search-modal-appear' ) ) {
					closeSearchModal();
				}
			}
		};
	};

	const initHero = ( heros ) => {
		$( 'body' ).addClass( 'has-hero-group' );
		if ( window.innerWidth <= screenBreakpoints.lg ) {
			const nextEl = $( heros[0] ).next();
			if ( nextEl.length > 0 ) {
				setTimeout( () => {
					let additional = 100;
					const nextElHeight = $( nextEl ).outerHeight( true );
					if ( nextElHeight > ( 3 * additional ) ) {
						additional = nextElHeight / 3;
					}

					if ( additional > 300 ) {
						additional = 300;
					}

					$( '.page-bg-top' ).css( {
						height: $( nextEl ).offset().top + additional
					});

					if ( $( '#page-background' ) ) {
						$( '#page-background' ).css( { 'margin-bottom': $( '#colophon' ).outerHeight( true ) } );
					}
				}, 200 );
			}
		}

	};

	const initPageHero = () => {
		if ( $( '.page-bg-top' ).length === 0 ) {
			return;
		}

		const heros = $( '.wp-block-group.hero' );
		if ( heros.length > 0 ) {
			initHero( heros );
			return;
		}

		const entryHeaders = document.querySelectorAll( 'header.entry-header' );
		if ( entryHeaders.length > 0 ) {
			const firstHeader = entryHeaders[0];
			const bodyStyles = window.getComputedStyle(document.body);
			const spacing = parseInt( bodyStyles.getPropertyValue('--global--spacing-vertical') ); 
			setTimeout( () => {
				let additional = 400 - $( '#masthead' ).outerHeight( true );
				$( firstHeader ).css( {
					'height': additional - 2 * spacing
				});

				$( '.page-bg-top' ).css( {
					height: additional - 2 * spacing + additional
				});

				if ( $( '#page-background' ) ) {
					$( '#page-background' ).css( { 'margin-bottom': $( '#colophon' ).outerHeight( true ) } );
				}
			}, 100 );
		}

		

	};

	const initFirstEntryHeader = () => {
		const entryHeaders = document.querySelectorAll( 'header.entry-header' );
		if ( entryHeaders.length > 0 ) {
			entryHeaders[0].classList.add( 'first-header' );
		}
	};

	const initAccordion = ( container ) => {
		const $container = $( container );
		const details = $( '.m3-accordion details', $container );
		if ( details.length === 0 ) {
			return;
		}

		const closeOtherDetails = ( opened_idx ) => {
			details.each( ( idx, a_detail ) => {
				if ( idx != opened_idx ) {
					$( a_detail ).attr( 'open', false );
				}
			});
		};

		const setupClickEvent = () => {
			$( '.m3-accordion', $container ).each( ( idx, m3_accordion ) => {
				const $m3_accordion = $( m3_accordion );
				$( 'summary', $m3_accordion ).on( 'click', ( ev ) => {
					ev.preventDefault();
					const detail = $( ev.currentTarget ).parents( 'details' );
					const dest 	 = $( ev.currentTarget ).parents( '.m3-accordion' ).attr( 'id');
					if ( detail.get()[0].open ) {
						detail.attr( 'open', false );
						history.replaceState( {}, null, '.' );
					} else {
						detail.attr( 'open', 1 );
						if ( dest !== '' ) {
							history.pushState( { tab: dest }, '', `#${dest}` );
						}
						closeOtherDetails( details.index( detail ) );
						$( 'html, body' ).animate(
							{
								scrollTop: ( $( ev.target ).offset().top - $( '#masthead' ).outerHeight() - 160 )
							}, {
								duration: 600
							}
						);
					}
				});
			});
		};

		let hash = window.location.hash;
		if ( hash ) {
			const m3_accordion = $( hash );
			if ( m3_accordion ) {
				$( 'details', m3_accordion ).attr( 'open', 1 );
			}
		}
		setupClickEvent();
	};

	const initAccordions = () => {
		const containers = $( '.m3-accordion-container' );
		if ( containers.length === 0 ) {
			return;
		}
		$.each( containers, ( idx, container ) => {
			initAccordion( container );
		});
	};

	const initInnerFlushContainer = () => {
		const $flush_with_single_contents = $( '.flush-with-single-content' );
		if ( $flush_with_single_contents.length === 0 ) {
			return;
		}
		if ( window.innerWidth < screenBreakpoints.lg ) {
			return;
		}
		$.each( $flush_with_single_contents, ( idx, flush_with_single_content ) => {
			const nextEl = $( flush_with_single_content ).next();
			if ( nextEl.length > 0 ) {
				$( flush_with_single_content ).css({ top: nextEl.position().top });
			}
		})
	};

	const initShareIcons = () => {
		const $containers = $( '.share-icons-container' );
		if ( $containers.length == 0 ) {
			return;
		}

		$.each( $containers, ( idx, container ) => {
			const $container = $( container );
			const m3_icons = $( '<div>' ).addClass( 'm3-icon' ).html( '<span class="icon"></span>' );
			$( '.sfsi_wicons a.sficn', $container ).append( m3_icons );
			$( '.sfsi_wicons a.sficn .m3-icon', $container ).on( 'mouseenter', ( ev ) => {
				$( ev.currentTarget ).prev( 'img' ).trigger( 'mouseenter' );
			});
			$( '.sfsi_wicons a.sficn .m3-icon', $container ).on( 'click', ( ev ) => {
				$( ev.currentTarget ).prev( 'img' ).trigger( 'click' );
				setTimeout( () => {
					$( ev.currentTarget ).parent( 'a.sficn' ).siblings( 'div.sfsi_tool_tip_2' ).show();
				}, 200 );
			});
		});

	};

	const initSubMenuToggle = () => {
		const submenu_toggles = $( '.primary-menu-container .sub-menu-toggle' );
		if ( submenu_toggles.length == 0 ) {
			return;
		}

		$( '#primary-menu-list > .current-menu-ancestor' ).addClass( 'expanded' );

		submenu_toggles.on( 'click', ( ev ) => {
			ev.preventDefault();
			const expanded = $( ev.currentTarget ).attr( 'aria-expanded' );
			$( ev.currentTarget ).parents( '.menu-item' ).toggleClass( 'expanded' );
		});
	};

	const initM3TaxonomyList = () => {
		if ( $( 'body' ).hasClass( 'has-screen-size-xxl' ) || $( 'body' ).hasClass( 'has-screen-size-xl' ) || $( 'body' ).hasClass( 'has-screen-size-lg' ) ) {
			return;
		}

		const m3_taxonomy_lists = $( '.m3-taxonomy-list' );
		if ( m3_taxonomy_lists.length === 0 ) {
			return;
		}

		$.each( m3_taxonomy_lists, ( idx, m3_taxonomy_list ) => {
			const $m3_taxonomy_list = $( m3_taxonomy_list );
			$( '.current-term-container', $m3_taxonomy_list ).on( 'click', ( ev ) => {
				ev.preventDefault();
				$m3_taxonomy_list.toggleClass( 'dropdown-active' );
			});
		});
	};

	const initLeadership = () => {
		const persons = $( '.leadership .m3-person' );
		if ( persons.length === 0 ) {
			return;
		}

		setTimeout( () => {
			const width = $( persons[ 0 ] ).outerWidth();
			for ( let i = 1; i <= 3; i++ ) {
				$( persons[ persons.length - i ] ).width( width );
			}
		}, 500 );
	};

	const initSectionWithIcon = () => {
		if ( window.innerWidth < screenBreakpoints.sm ) {
			return;
		}

		const containers = $( '.column-icons' );
		if ( containers.length === 0 ) {
			return;
		}

		setTimeout( () => {
			containers.each( ( idx, container ) => {
				const columns = $( '.gb-layout-column-wrap > .wp-block-genesis-blocks-gb-column > .gb-block-layout-column-inner', $( container ) );
				if ( columns.length > 0 ) {
					columns.css( 'height', 'auto' );
				}
				let col_height = 0;
				columns.each( ( idx, el ) => {
					if ( $( el ).outerHeight() > col_height ) {
						col_height = $( el ).outerHeight();
					}
				});
				columns.css( 'height', col_height );
			});
		}, 500 );

	};

	const initDemoForm = () => {
		if ( $( '#m3-demo-form-container' ).length === 0 ) {
			return;
		}

		$( '.book-a-demo-button' ).each( ( idx, btn_container ) => {
			const $container = $( btn_container );
			$( 'a', $container ).attr( 'href', m3_solutions_script_vars.demo_url ).attr( 'target', '_blank' );
		});

		/*

		$( '.book-a-demo-button' ).on( 'click', ( ev ) => {
			ev.preventDefault();
			$( document ).on( 'keyup', handleEscClicked );
			$( 'body' ).addClass( 'demo-form-displayed' );
			$( '#m3-demo-form-container' ).show();
		});

		const closeForm = () => {
			$( document ).off( 'keyup', handleEscClicked );
			$( 'body' ).removeClass( 'demo-form-displayed' );
			$( '#m3-demo-form-container' ).hide();
		};

		$( '#m3-demo-form-container .btn-close' ).on( 'click', ( ev ) => {
			ev.preventDefault();
			closeForm();
		});

		const handleEscClicked = ( ev ) => {
			if ( ev.key == 'Escape' ) {
				if ( $( 'body' ).hasClass( 'demo-form-displayed' ) ) {
					closeForm();
				}
			}
		};
		*/

	};

	const initGotoTop = () => {
		$( document ).on( 'click', 'body.has-goto-top #m3-goto-top-container', ( ev ) => {
			ev.preventDefault();
			$( 'html, body' ).animate(
				{
					scrollTop: $( 'body' ).offset().top
				}, {
					duration: 600
				}
			);
		})
	};

	const playVideo = ( video_player ) => {
		video_player.parentElement.classList.add( 'playing' );
		video_player.controls = true;
		video_player.play();
	};

	const pauseVideo = ( video_player ) => {
		video_player.parentElement.classList.remove( 'playing' );
		video_player.controls = false;
		video_player.pause();
	};

	const initVideoPlayers = () => {
		const video_players = document.querySelectorAll( '.wp-block-video video' );
		if ( video_players.length > 0 ) {
			video_players.forEach( ( video_player ) => {
				video_player.addEventListener( 'click', ( ev ) => {
					ev.preventDefault();
					if ( !video_player.parentElement.classList.contains( 'playing' ) ) {
						playVideo( video_player );
					} else {
						pauseVideo( video_player );
					}
					ev.stopPropagation();
				});

				video_player.parentElement.addEventListener( 'click', ( ev ) => {
					ev.preventDefault();
					if ( !video_player.parentElement.classList.contains( 'playing' ) ) {
						playVideo( video_player );
					} else {
						pauseVideo( video_player );
					}
				});
			});
		}
	}

	$( function() {
		if ( isTouchDevice() ) {
			$( 'html' ).addClass( 'touch' );
		};
		// Some of the initializations are from from initHeader.
		initHeader();
		initSearch();
		initFirstEntryHeader();
		initAccordions();
		initShareIcons();
		initSubMenuToggle();
		initDemoForm();
		initGotoTop();
		initVideoPlayers();
	});
	
}) ( jQuery, window, document );

// Injection ends